<template>
  <div class="main">
    <Breadcrumb :options="breadcrumb" />

    <TabMenu v-if="user.group_name != 'Cashier'" :menuIndex="menuIndex" :menu="menu" />

    <div>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import {
  mapState,
} from "vuex";

export default {
  data() {
    return {
      breadcrumb: [
        { name: "财务管理" },
        { name: "报销管理" },
      ],
      menuIndex: `/finance/reimburse/table`,
      menu: [
        {
          name: "待审核",
          path: `/finance/reimburse/table`,
        },
        {
          name: "已审核",
          path: `/finance/reimburse/tableChecked`,
        },
      ],
    };
  },
  computed: {
    ...mapState([
      'user',
    ]),
  },
  methods: {},
  mounted() {
    this.menuIndex = `${this.$route.path}`
  },
};
</script>
